import axios from 'axios';
import { useQuery } from '@tanstack/react-query';

export const getPreviousOrders = (studentId) => {
  return useQuery([studentId, 'haspreviousOrders'], () => {
    return axios.get(`/students/has_previous_orders?student_id=${studentId}` )
      .then((data) => {
        if (!data.data) return false;

        return data.data.data;
    });
  }, { placeholderData: false, enabled: !!studentId });
};

